import React from 'react';
import { Target, CheckCircle2, Settings } from 'lucide-react';

const money = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €`;

const Bar = ({ label, unit, block, testId }) => {
  const pct = Math.min(block.pct || 0, 100);
  const color = block.reached ? 'bg-green-500' : pct >= 60 ? 'bg-orange-500' : 'bg-red-500';
  const projMarker = block.projected_pct != null && !block.reached ? Math.min(block.projected_pct, 100) : null;
  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between text-sm mb-1">
        <p className="font-medium text-gray-800 flex items-center gap-1">{label} <span className="text-xs text-gray-400">({unit})</span>{block.reached && <CheckCircle2 size={15} className="text-green-600" data-testid={`${testId}-reached`} />}</p>
        <p className="text-gray-700"><strong data-testid={`${testId}-actual`}>{money(block.actual)}</strong> / {money(block.target)} · <span className={`font-semibold ${block.reached ? 'text-green-700' : 'text-gray-900'}`} data-testid={`${testId}-pct`}>{block.pct} %</span></p>
      </div>
      <div className="relative h-3 bg-gray-100 rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-[width] duration-700 ${color}`} style={{ width: `${pct}%` }} />
        {projMarker != null && <div className="absolute top-0 h-full w-0.5 bg-gray-700/70" style={{ left: `${projMarker}%` }} title={`Projection fin de mois : ${block.projected_pct} %`} />}
      </div>
      <p className="text-xs text-gray-500 mt-1" data-testid={`${testId}-remaining`}>
        {block.reached ? `Objectif atteint — dépassé de ${money(block.actual - block.target)}` : `Reste à faire : ${money(block.remaining)}`}
        {block.projected != null && !block.reached && <> · Projection fin de mois au rythme actuel : <strong className={block.projected_pct >= 100 ? 'text-green-700' : 'text-red-600'}>{money(block.projected)} ({block.projected_pct} %)</strong></>}
      </p>
    </div>
  );
};

// Reports: monthly revenue / margin targets with progress bars
const SalesTargets = ({ targets, onOpenSettings }) => {
  if (!targets) return null;
  const hasAny = targets.revenue_ttc.target > 0 || targets.margin_ht.target > 0;
  return (
    <div className="bg-white rounded-lg shadow-sm p-4" data-testid="sales-targets">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h3 className="font-semibold text-gray-900 flex items-center gap-2"><Target size={18} className="text-orange-500" /> Objectifs du mois</h3>
        <p className="text-xs text-gray-500">{targets.is_current ? `Jour ${targets.days_elapsed} / ${targets.days_in_month}` : `${targets.days_in_month} jours`}</p>
      </div>
      {!hasAny ? (
        <p className="text-sm text-gray-500 flex flex-wrap items-center gap-2" data-testid="sales-targets-empty">
          Aucun objectif défini. <button type="button" onClick={onOpenSettings} className="inline-flex items-center gap-1 text-orange-600 hover:underline font-medium" data-testid="sales-targets-settings-link"><Settings size={13} /> Définir les objectifs dans Paramètres</button>
        </p>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {targets.revenue_ttc.target > 0 && <Bar label="Chiffre d'affaires" unit="TTC" block={targets.revenue_ttc} testId="target-revenue" />}
          {targets.margin_ht.target > 0 && <Bar label="Marge" unit="HT" block={targets.margin_ht} testId="target-margin" />}
        </div>
      )}
    </div>
  );
};

export default SalesTargets;
